export default __webpack_public_path__ + "static/media/tag-icon-mindfulness.d0f1fc72.svg";